// frontend/src/pages/OnboardingPage/routes/IntegrationCategoryRoute.tsx
import React from "react";
import { graphql, useLazyLoadQuery, useRefetchableFragment } from "react-relay";
import { Navigate, useParams } from "react-router";
import { getCategoryBySlug } from "src/components/integrations/integration-categories";

import { IntegrationCategoryContent_organization$key } from "../components/__generated__/IntegrationCategoryContent_organization.graphql";
import IntegrationCategoryContent from "../components/IntegrationCategoryContent";
import { IntegrationCategoryRouteQuery } from "./__generated__/IntegrationCategoryRouteQuery.graphql";

const integrationCategoryRouteQuery = graphql`
  query IntegrationCategoryRouteQuery {
    me {
      ...appMe
      organization {
        ...IntegrationCategoryRoute_organization
      }
    }
  }
`;

const integrationCategoryRouteFragment = graphql`
  fragment IntegrationCategoryRoute_organization on GraphQLOrganization
  @refetchable(queryName: "IntegrationCategoryRouteRefetchQuery") {
    ...IntegrationCategoryContent_organization
  }
`;

export default function IntegrationCategoryRoute() {
  const { categorySlug } = useParams<{ categorySlug: string }>();
  const category = categorySlug ? getCategoryBySlug(categorySlug) : undefined;

  const data = useLazyLoadQuery<IntegrationCategoryRouteQuery>(
    integrationCategoryRouteQuery,
    {},
    { fetchPolicy: "store-or-network" }
  );

  const organizationData = data.me?.organization;
  const [organization, refetch] = useRefetchableFragment(
    integrationCategoryRouteFragment,
    organizationData
  );

  // Redirect if category slug is invalid
  if (!category) {
    return <Navigate to="/onboarding" replace />;
  }

  // Wait for organization data
  if (!organization) {
    return null;
  }

  const handleRefetch = () => {
    refetch({}, { fetchPolicy: "network-only" });
  };

  return (
    <IntegrationCategoryContent
      category={category}
      organization={organization as IntegrationCategoryContent_organization$key}
      onRefetch={handleRefetch}
    />
  );
}
